import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import ErrorBoundary from "./components/global/ErrorBoundary";

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;